var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgEdit = function SvgEdit(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 14.914 14.914",
    stroke: "#fff",
    fill: "#fff"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_feather-edit-2",
    "data-name": "Icon feather-edit-2",
    d: "M12.64,3.79A1.818,1.818,0,0,1,15.21,6.36L6.535,15.036,3,16l.964-3.535Z",
    transform: "translate(-2 -2.086)",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })));
};
export default SvgEdit;